import rentObjectBookingsService from "@/services/rentObjectBookingsService";

const state = () => ({
  temporaryBooking: null,
  newBookingCalculation: null,
  searchAndFilterMode: 'search',
  all: [],
  single: null
});

const actions = {
  async create({ commit, dispatch }, formData) {
    commit("setSingle", null);
    try {
      const res = await rentObjectBookingsService.create(formData);
      commit("setSingle", res.data);
      dispatch(
        "common/showSuccess",
        `Vorgang #${res.data.id} wurde erfolgreich erstellt.`,
        { root: true }
      );
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Vorgang konnte nicht erstellt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, payload) {
    try {
      const res = await rentObjectBookingsService.findAll(payload);
      commit("setAll", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Vorgänge konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async getDashboard({ dispatch }, payload) {
    try {
      const res = await rentObjectBookingsService.getDashboard(payload);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Dashboard konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async getChannelRequests({ dispatch }, payload) {
    try {
      const res = await rentObjectBookingsService.getChannelRequests(payload);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Channel-Anfragen konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async anonymize({ dispatch }, {id}) {
    try {
      await rentObjectBookingsService.anonymize({id});
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchung konnte nicht anonymisiert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAllByStatus({ commit, dispatch }, payload) {
    try {
      const res = await rentObjectBookingsService.findAllByStatus(payload);
      commit("setAll", res.data);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Vorgänge konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findOne({ commit, dispatch }, { id }) {
    commit("setSingle", null);
    try {
      const res = await rentObjectBookingsService.findOne({ id });
      commit("setSingle", res.data);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Vorgang konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findByIdForBookingCalendar({ commit, dispatch }, { id }) {
    commit("setSingle", null);
    try {
      const res = await rentObjectBookingsService.findByIdForBookingCalendar({ id });
      commit("setSingle", res.data);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Vorgang konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async offerPDFPreview({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.offerPDFPreview(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebotsvorschau konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async offerMultiplePDFPreview({ dispatch }, { offers }) {
    try {
      const res = await rentObjectBookingsService.offerMultiplePDFPreview({ offers });
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebotsvorschau konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async contractPDFPreview({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.contractPDFPreview(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Vertragsvorschau konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async cancelInvoicePDFPreview({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.cancelPDFPreview(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Stornierungsvorschau konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async paymentReminder1PDFPreview({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.paymentReminder1PDFPreview(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Mahnungsvorschau konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async paymentReminder2PDFPreview({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.paymentReminder2PDFPreview(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Mahnungsvorschau konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await rentObjectBookingsService.delete({ id });
      dispatch("findAll");
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Vorgang konnten nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async update({ dispatch }, formData) {
    try {
      await rentObjectBookingsService.update(formData);
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Vorgang wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Vorgang konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateCustomer({ dispatch }, formData) {
    try {
      await rentObjectBookingsService.updateCustomer(formData);
      dispatch(
        "common/showSuccess",
        "Buchungs-Gast wurde aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungs-Gast konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateData({ dispatch }, formData) {
    try {
      await rentObjectBookingsService.updateData(formData);
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Buchung wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchung konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateComment({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.updateComment(formData);
      dispatch(
        "common/showSuccess",
        "Anmerkung zur Buchung wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Anmerkung zur Buchung konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateReferral({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.updateReferral(formData);
      dispatch(
        "common/showSuccess",
        "Buchungsquelle wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungsquelle konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateInstantPayment({ dispatch }, formData) {
    try {
      await rentObjectBookingsService.updateInstantPayment(formData);
      dispatch(
        "common/showSuccess",
        `Sofortzahlung wurde für diese Buchung ${formData.instantPayment ? 'aktiviert' : 'deaktiviert'}.`,
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Sofortzahlung konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateBookingStatus({ dispatch }, formData) {
    try {
      await rentObjectBookingsService.updateBookingStatus(formData);
      dispatch("findAll");
      dispatch(
        "common/showSuccess",
        "Status der Vorgang wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Status der Vorgang konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateSignedContract({ dispatch }, formData) {
    try {
      await rentObjectBookingsService.updateSignedContract(formData);
      dispatch(
        "common/showSuccess",
        "Neuer unterschriebener Vertrag wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Neuer unterschriebener Vertrag konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async updateDisablePaymentReminder({ dispatch }, formData) {
    try {
      await rentObjectBookingsService.updateDisablePaymentReminder(formData);
      dispatch(
        "common/showSuccess",
        "Mahnstop wurde erfolgreich aktualisiert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Mahnstop konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async findArrivals({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.findArrivals(formData);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Anreisen konnten nicht gefunden werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async findDepartures({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.findDepartures(formData);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Abreisen konnten nicht gefunden werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async findCleaningDates({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.findCleaningDates(formData);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Endreinigungen konnten nicht gefunden werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async findBookingItems({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.findBookingItems(formData);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungseinträge konnten nicht gefunden werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async findBookingItemsCreatedAt({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.findBookingItemsCreatedAt(formData);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Buchungseinträge (Erstellungsdatum) konnte nicht gefunden werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async findAllBookings({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.findAllBookings(formData);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Alle Buhcungen konnten nicht geladen werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async setCheckIn({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.setCheckIn(formData);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Check in konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async setCheckOut({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.setCheckOut(formData);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Check out konnte nicht aktualisiert werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async restore({ dispatch }, formData) {
    try {
      await rentObjectBookingsService.restore(formData);
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Wiederherstellung der Buchung hat nicht geklappt.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async calculatePrice({ dispatch }, formData) {
    try {
      const res = await rentObjectBookingsService.calculatePrice(formData);
      return Promise.resolve(JSON.parse(JSON.stringify(res.data)));
    } catch (error) {
      dispatch(
        "common/showError",
        "Preis konnte nicht berechnet werden.",
        { root: true }
      );
      return Promise.reject();
    }
  },
  async search({ dispatch }, payload) {
    try {
      const res = await rentObjectBookingsService.search(payload);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Vorgänge konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async checkOpenPaymentsAgain({ dispatch }, payload) {
    try {
      const res = await rentObjectBookingsService.checkOpenPaymentsAgain(payload);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Es konnte keine Überprüfung stattfinden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async sendArrivalEmail({ dispatch }, payload) {
    try {
      const res = await rentObjectBookingsService.sendArrivalEmail(payload);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Anreise E-Mail konnte nicht verschickt werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async archiveArrivalEmail({ dispatch }, payload) {
    try {
      const res = await rentObjectBookingsService.archiveArrivalEmail(payload);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Anreise E-Mail konnte nicht ausgeblendet werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  }
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
  setSearchAndFilterMode(state, payload) {
    state.searchAndFilterMode = payload;
  },
  setNewBookingCalculation(state, payload) {
    state.newBookingCalculation = payload;
  },
  setTemporaryBooking(state, payload) {
    state.temporaryBooking = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
